export default "__VITE_ASSET__e684dd95__"